/*
* Component for an image that transitions between array of images.
* (Homepage)
*/
<template>
  <div class="grid-images">
		<template v-for="(num,s) in slotOrder" :key="s">
			<div class="image" :data-order="num">
				<img v-for="(img,i) in payload" :key="`cycle_image_${s}_${i}`" :src="img" alt="" loading="lazy" :data-id="i"/>
			</div>
		</template>
  </div>
</template>

<script>

  export default {
    name: 'transitionImages',

   	props: {
      payload: {
        type: Array,
        required: true
      }
		},

   	data() {
      return {
				interval: 0,
				order: [], // the shuffled order we'll use to load the payload images
				slotOrder: [], // Our 4 slots containing the index of the image to show.
				maxSlots: 4, // Max number of slots on screen
				activeSlot: 0
      }
    },

		created() {
			this.order = [];
			this.payload.forEach((item,i) => {
				this.order.push(i);
			})

			this.order = this.shuffleArray(this.order);
			console.log("order",this.order);

			for(var i = 0; i < this.maxSlots; i++) {
				this.slotOrder.push(false);
				this.switchImage();
			}

		},

    mounted() {
			this.interval = setInterval(this.switchImage, 3000);
    },

    beforeDestroy() {
      clearInterval(this.interval);
    },

    methods: {
			switchImage() {
				// If the slot orders already contain a value, put it back on the end of the orders array.
				if (this.slotOrder[this.activeSlot] !== false) {
					this.order.push(this.slotOrder[this.activeSlot]);
				}

				// Now grab the first item and use it.
				let nextVal = this.order.shift();
				this.slotOrder[this.activeSlot] = nextVal;
				this.readyNextSlot();
			},

			readyNextSlot() {
				// If the next slot is less than our max, all good, otherwise revert to the start
				if (this.activeSlot + 1 < this.maxSlots) {
					this.activeSlot += 1;
				} else {
					this.activeSlot = 0;
				}
			},

			shuffleArray(array) {
				for (let i = array.length - 1; i > 0; i--) {
					// Generate a random index from 0 to i
					const j = Math.floor(Math.random() * (i + 1));
					// Swap elements at indices i and j
					[array[i], array[j]] = [array[j], array[i]];
				}
				return array;
			}
    }
  };
</script>
